import { useState, useEffect } from "react";
import HRDashBoard from "../../ui/HRDashboard";
import RoleBasedLayout from "../RoleBasedLayout";
import ExpensesPage from "../../ui/ExpensesPage";
import HiringPage from "../../ui/HiringPage";
import LetterPage from "../../ui/LetterPage";
import PayRollPage from "../../ui/PayRollPage";
import { LayoutDashboard, BanknoteArrowDown, Triangle, BadgeDollarSign } from "lucide-react";
import { useLocation } from "wouter";

export default function IsAdminHr() {
    const [activeTab, setActiveTab] = useState("dashboard");
    const [currentPath] = useLocation();

    const tabs = [
        { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
        { id: "expenses", label: "Expenses", icon: BanknoteArrowDown },
        { id: "hiring", label: "Hiring", icon: Triangle },
        { id: "payRoll", label: "PayRoll", icon: BadgeDollarSign },
    ];

    const renderTabContent = () => {
        switch (activeTab) {
            case "dashboard":
                return <HRDashBoard />;
            case "expenses":
                return <ExpensesPage />;
            case "hiring":
                return <HiringPage />;
            case "letters":
                return <LetterPage />;
            case "payRoll":
                return <PayRollPage />;
            default:
                return null;
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tab = params.get("tab");

        if (tab) {
            setActiveTab(tab);
        } else {
            setActiveTab("dashboard");
        }
    }, []);

    return (
        <RoleBasedLayout>
            <div className="tabs-container mb-0 ex:mt-[13px] lg:mt-[20px] xl:mt-[0px] ">
                <div className='tabs-header flex border-b text-sm border-gray-300 mb-4 fixed w-full bg-white z-20'>
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => {
                                setActiveTab(tab.id);
                                window.history.pushState(null, "", `?tab=${tab.id}`);
                            }}
                            className={`px-2 zs:px-4 py-2 rounded-t-lg font-medium
      transition-all duration-200
      flex items-center gap-2
      text-[12px] lg:text-sm
       ${activeTab === tab.id
                                    ? "bg-blue-50 text-blue-600 border-b-2 border-blue-600"
                                    : "border-transparent text-gray-500 hover:text-blue-500"
                                }`}
                        >
                            <div className="flex gap-1 items-center">
                                {tab.icon && (
                                    <span className="hidden sm:block mr-2">
                                        <tab.icon size={18} />
                                    </span>
                                )}
                                {tab.label}
                            </div>
                        </button>
                    ))}
                </div>

                <div className="tabs-content pt-[50px]">
                    {renderTabContent()}
                </div>
            </div>
        </RoleBasedLayout>
    );
}
